import { render, staticRenderFns } from "./LoaderPacman.vue?vue&type=template&id=1b071ff3&"
import script from "./LoaderPacman.vue?vue&type=script&lang=js&"
export * from "./LoaderPacman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports